import { useState } from 'react';
import { IoPlay, IoVideocamOutline } from 'react-icons/io5';

import { Box, Center, Image } from '@mantine/core';

import { Collateral } from 'models';
import { CollateralHelpers } from 'helpers/CollateralHelpers';

import { CollateralPage } from 'components/collateral/CollateralPage';

import cx from './CollateralCover.module.scss';

const CollateralCover = ({
    collateral,
    width,
    alt,
    iconSize = 48,
}: {
    collateral: Pick<Collateral, 'file' | 'videoUrl' | 'videoThumbnail'>;
    width: number;
    alt: string;
    iconSize?: number;
}) => {
    const file = CollateralHelpers.file(collateral);

    if (!CollateralHelpers.isPlayable(collateral)) {
        return file ? <CollateralPage file={file} width={width} alt={alt} iconSize={iconSize} /> : null;
    }

    return (
        <Box className={cx.video}>
            {file ? (
                <CollateralPage file={file} width={width} alt={alt} iconSize={iconSize} />
            ) : (
                <VideoLinkThumbnail src={collateral.videoThumbnail} alt={alt} iconSize={iconSize} />
            )}
            <Center className={cx.play}>
                <IoPlay />
            </Center>
        </Box>
    );
};

const VideoLinkThumbnail = ({ src, alt, iconSize }: { src?: string | null; alt: string; iconSize: number }) => {
    const [failed, setFailed] = useState(false);

    if (!src || failed) {
        return (
            <Center className={cx.fallback}>
                <IoVideocamOutline size={iconSize} />
            </Center>
        );
    }

    return <Image src={src} alt={alt} loading="lazy" onError={() => setFailed(true)} />;
};

export { CollateralCover };
